import {Component, computed, input, output} from '@angular/core';
import {ChangeTodoStatusRequest, TodoStatusSelect, TodoSummary} from '../../../../../api';
import {TodoKanbanCard} from '../todo-kanban-card/todo-kanban-card';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import {Dot} from '../../../../components/dot/dot';
import {ElciaButton} from '../../../../components/buttons/button/button';

interface KanbanColumn {
  statusId: number | null;
  title: string;
  color: string;
  bgColor: string;
  todos: TodoSummary[];
}

@Component({
  selector: 'elcia-todo-kanban',
  imports: [TodoKanbanCard, Dot, CdkDropListGroup, CdkDropList, CdkDrag, ElciaButton],
  templateUrl: './todo-kanban.html',
  styleUrl: './todo-kanban.scss',
})
export class TodoKanban {
  highlightTodoId = input<number | null>(null);
  highlightChildId = input<number | null>(null);
  hiddenStatusIds = input<number[]>([]);
  todos = input<TodoSummary[]>([]);
  todoStatuses = input<TodoStatusSelect[]>([]);
  onEdit = output<TodoSummary>();
  onCompletionChange = output<TodoSummary>();
  onChildCompletionChange = output<TodoSummary>();
  onStatusChange = output<{ todoId: number, request: ChangeTodoStatusRequest }>();
  onAddTodo = output<number>();
  columns = computed<KanbanColumn[]>(() => {
    const allTodos = this.todos();
    const hidden = this.hiddenStatusIds();
    return this.todoStatuses().filter(s => !hidden.includes(s.id!)).map(status => {
      const hex = status.color ?? '#94a3b8';
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return {
        statusId: status.id!,
        title: status.name ?? '',
        color: hex,
        bgColor: `rgba(${r}, ${g}, ${b}, 0.1)`,
        todos: allTodos.filter(t => t.status?.id === status.id),
      };
    });
  });

  protected onDrop(event: CdkDragDrop<TodoSummary[]>): void {
    if (event.previousContainer === event.container && event.previousIndex === event.currentIndex) {
      return;
    }

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }

    const movedTodo = event.container.data[event.currentIndex];
    const statusId = event.container.id ? Number(event.container.id) : null;
    if (movedTodo?.id != null && statusId !== null) {
      this.onStatusChange.emit({
        todoId: movedTodo.id,
        request: {statusId, orderNum: event.currentIndex},
      });
    }
  }

  protected editTodo($event: TodoSummary) {
    this.onEdit.emit($event);
  }

  protected addTodo(statusId: number | null): void {
    if (statusId === null) return;
    this.onAddTodo.emit(statusId);
  }
}
